





















































import { Component, Vue } from 'vue-property-decorator';
import AddBankName from './modals/addBankName.vue';

   @Component({
      components:{AddBankName}
    })


export default class Banks extends Vue{

  isOpenModal:boolean=false;
  mockData:any[]=[];
  headers:any[]=[];
  breadcrumbsItems:any[]=[];


    created(){
      this.headers= [
          { text: 'Banka Adı',value: 'name' },
          { text: "İşlemler", value: "transactions" }

        ],
        this.mockData=[
          {
            name: 'Garanti',
          },

        ]

        this.breadcrumbsItems= [
          {text: 'Ana Sayfa',disabled: false,href: '/#/main/home'},
          {text: 'Finans',disabled: true},
          {text: 'Bankalar',disabled: true}
        
      ]


    }

    data () {
      return {
        page: 1,

      }

    }
    
    openModal(){
      this.isOpenModal=true;
    }
    closeModal(){
       this.isOpenModal = false;
    }
    
}




